import { styled } from "@mui/material/styles";
const ProfileLayoutMian = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    paddingTop: "10px",
  },
  [theme.breakpoints.between("md", "lg")]: {
    paddingTop: "40px",
  },
  [theme.breakpoints.down("md")]: {
    paddingTop: "10px",
  },
  [theme.breakpoints.up("lg")]: {
    paddingTop: "40px",
  },
}));
const ProfileLayoutWrap = styled("div")(({ theme }) => ({
  width: "90%",
  margin: "0 auto",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
  [theme.breakpoints.up("lg")]: {
    width: "90%",
  },
}));
const ProfileContactMain = styled("div")(({ theme }) => ({
  width: "100%",
}));

export { ProfileLayoutMian, ProfileLayoutWrap, ProfileContactMain };
